import React, { useState } from 'react';
import { Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

export default function UploaderFile(props) {
  const [fileList, setFileList] = useState([]);

  const uploadProps = {
    onRemove: file => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();

      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: file => {
      if (fileList.length >= props.maxCount) {
        return false;
      }

      setFileList([...fileList, file]);
      return false;
    },
    fileList,
    ...props,
  };

  return (
    <>
      <Upload {...uploadProps}>
        <Button icon={<UploadOutlined />}>请选择文件</Button>
      </Upload>
    </>
  );
}
